module.exports = __webpack_public_path__ + "media/logos/zwift-bf61dbbc.svg";